export default {
  data: function () {
    return {
      showAPCModal: false,
      APCState: 'ready',
      showPCModal: false,
      PCState: 'loading',
      showPMModal: false,
      PMState: 'loading',
      products: '',
      movements: '',
      selectedProduct: '',
      productHistory: '',
      shoot_type: [],
      table_columns: {
        'group_1': [{
          name: 'Parent',
          rowspan: 2,
          class: '',
          visible: true,
          module: ''
        }, {
          name: 'Items',
          rowspan: 2,
          class: '',
          visible: true,
          module: ''
        }, {
          name: 'Description',
          rowspan: 2,
          class: '',
          visible: true,
          module: ''

        }, {
          name: 'Reporting Classes',
          rowspan: 2,
          class: '',
          visible: true,
          module: ''

        }, {
          name: 'Workflow',
          colspan: 2,
          class: 'text-primary text-center b-r',
          visible: true,
          module: ''
        }, {
          name: 'Retouch',
          colspan: 2,
          class: 'text-primary text-center b-r',
          visible: true,
          module: 'photodesk'
        }, {
          name: 'Copy',
          colspan: 4,
          class: 'text-primary text-center b-r',
          visible: true,
          module: 'copydesk'
        }, {
          name: 'Dispatch',
          colspan: 1,
          class: 'text-primary text-center b-r',
          visible: true,
          module: 'photodesk'
        }, {
          name: 'Dispatch',
          colspan: 2,
          class: 'text-primary text-center b-r',
          visible: true,
          module: 'copydesk'
        }, {
          name: 'Actions',
          rowspan: 2,
          class: 'text-primary text-center b-r',
          visible: true,
          module: ''
        }],
        'group_2': [{
          name: 'Shot',
          rowspan: 1,
          colspan: 2,
          class: 'text-center b-r',
          visible: true,
          module: 'photodesk'
        },
        {
          name: 'Status',
          colspan: 2,
          rowspan: 1,
          class: 'text-center b-r',
          visible: true,
          module: 'photodesk'
        },
        {
          name: 'Write',
          colspan: 2,
          rowspan: 1,
          class: '',
          visible: true,
          module: 'copydesk'
        },
        {
          name: 'Review',
          colspan: 2,
          rowspan: 1,
          class: 'b-r',
          visible: true,
          module: 'copydesk'
        },
        {
          name: 'Images',
          rowspan: 1,
          colspan: 1,
          class: 'text-center b-r',
          visible: true,
          module: 'photodesk'
        },
        {
          name: 'Copy',
          rowspan: 1,
          colspan: 1,
          class: 'text-center b-r',
          visible: true,
          module: 'copydesk'
        }
        ]
      },
      table_columns_rms: '',
      product_columns: []
    }
  },
  created: function () {
    this.products = this.worklistdata.data
    this.updateColumns()
  },
  methods: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString().replace(/_/g, ' ')
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    secondsFormat: function (s) {
      var fm = [
        Math.floor(s / 60 / 60 / 24),
        Math.floor(s / 60 / 60) % 24,
        Math.floor(s / 60) % 60,
        s % 60
      ]
      return $.map(fm, function (v, i) {
        return ((v < 10) ? '0' : '') + v
      }).join(':')
    },
    isEmpty: function (str) {
      return (str == null || !str || str.length === 0 || str == 'null')
    },
    checkForceComplete (row) {
      return row.is_force_complete == 1
    },
    checkForceComplete (row) {
      return row.is_force_complete == 1
    },
    formatPreview (url) {
      if (url == null || url == '') {
        return 'http://www.theemailcompany.com/wp-content/uploads/2016/02/no-image-placeholder-big-300x200.jpg'
      }

      return url
    },
    formatProductFlags (row) {
      var flags = []
      // if (!this.isEmpty(row.location) && row.location == 'Styling Closet' && row.checkout_date == null) {
      flags.push('Styling')
      // }
      if (!this.isEmpty(row.comments) && row.comments > 0) {
        flags.push('Comment')
      }
      if (row.is_force_complete == 1) {
        flags.push('ForceComplete')
      }
      return flags
    },

    formatInboundDate (row) {
      var inbound_date = row.inbound_at
      return inbound_date
    },
    formatOutboundDate (row) {
      var outbound_date = row.outbound_at
      return outbound_date
    },
    formatInboundAt (row) {
      var inbound_date = this.formatInboundDate(row)
      if (inbound_date == null) return null
      return this.moment(inbound_date).format('Do MMM, YYYY')
    },
    formatOutboundAt (row) {
      var outbound_date = this.formatOutboundDate(row)
      if (outbound_date == null) return 'Pending Outbound'
      return this.moment(outbound_date).format('Do MMM, YYYY')
    },
    formatShootDate (row) {
      if (row.shoot_date == null) return null
      if (row.shoot_count == 0) return null
      return this.moment(row.shoot_date).format('Do MMM, YYYY')
    },
    formatWeekNumber (row) {
      return row.week_number - 3
    },
    formatImageName (row) {
      if (!row.brand_name) return null
      if (String(row.brand_name).toLowerCase().trim() == 'gap') {
        return row.Item_Parent + '_' + row.VPN + '_' + row.GAP_Color_Code
      } else {
        return row.Item_Parent + '_' + row.ATG_Color_Code
      }
    },
    formatShotStatus (row) {
      var self = this
      if (row.shoot_count > 0) {
        return 'Yes'
      } else {
        return 'No'
      }
    },

    formatCopyCompleteSessions (row) {
      var self = this
      let required_session = String(row.copy_required_session).split(',')

      let final_status = []

      required_session !== null && required_session.forEach(function (session) {
        if (row[`${session}_write_date`] !== null) {
          final_status.push({
            'session': self.capitalize(session),
            'writer': row[`${session}_writer`],
            'date': row[`${session}_write_date`],
            'status': 'Yes'
          })
        } else {
          final_status.push({
            'session': self.capitalize(session),
            'writer': 'Pending',
            'status': 'No'
          })
        }
      })
      return final_status
    },

    formatCopySubmitSessions (row) {
      var self = this
      let required_session = String(row.copy_required_session).split(',')

      let final_status = []

      required_session !== null && required_session.forEach(function (session) {
        if (row[`${session}_review_date`] !== null) {
          final_status.push({
            'session': self.capitalize(session),
            'reviewer': row[`${session}_reviewer`],
            'date': row[`${session}_review_date`],
            'status': 'Yes'
          })
        } else {
          final_status.push({
            'session': self.capitalize(session),
            'writer': 'Pending',
            'status': 'Pending'
          })
        }
      })
      return final_status
    },

    formatCompleteSessions (row) {
      var self = this
      let required_session = String(row.required_session).split(',')
      let complete_session = String(row.complete_session).split(',')
      let skip_session = String(row.skip_session).split(',')

      let final_status = []

      complete_session !== null && complete_session.forEach(function (session) {
        !self.isEmpty(session) && final_status.push({
          'session': self.capitalize(session),
          'photographer': row[`${session}_photographer`],
          'location': row[`${session}_location`],
          'date': row[`${session}_date`],
          'status': 'Yes'
        })
      })

      skip_session !== null && skip_session.forEach(function (session) {
        !self.isEmpty(session) && final_status.push({
          'session': self.capitalize(session),
          'photographer': 'Skipped',
          'status': 'Skipped'
        })
      })

      required_session !== null && required_session.forEach(function (session) {
        if (complete_session.indexOf(session) > -1 || skip_session.indexOf(session) > -1) {
          return
        }!self.isEmpty(session) && final_status.push({
          'session': self.capitalize(session),
          'photographer': 'Pending',
          'status': 'No'
        })
      })

      return final_status
    },

    formatRetouchSent (row) {
      var self = this
      if (row.retouch_sent_count > 0) {
        return 'Yes'
      } else {
        return 'No'
      }
    },

    formatCopyWrite (row) {
      if (this.checkForceComplete(row) == true) {
        return 'Yes'
      }
      if (row.copy_write_at == null) {
        return 'Pending'
      } else {
        return 'Yes'
      }
    },

    formatCopyReview (row) {
      if (this.checkForceComplete(row) == true) {
        return 'Yes'
      }
      if (row.copy_review_at == null) {
        return 'Pending'
      } else {
        return 'Yes'
      }
    },

    formatFinalCopy (row) {
      if (this.checkForceComplete(row) == true) {
        return 'Yes'
      }
      if (row.copy_sent_at == null) {
        return 'Pending'
      } else {
        return 'Yes'
      }
    },

    formatRetouchReceived (row) {
      var status, status_at, icon, status_by
      // If there is receiving status, that wins the status box, otherwise show sent status
      // If product is force completed, that overrides all statuses

      if (row.retouch_sent_count > 0) {
        // Is any thing received
        if (row.retouch_sent_count > row.retouch_received_count) {
          icon = 'Pending'
          status = (row.retouch_sent_count - row.retouch_received_count) + ' Pending Retouch'
        }

        if (row.retouch_sent_count == row.retouch_received_count) {
          if (row.retouch_received_by) {
            icon = 'Yes'
            status = 'Approved'
            status_by = row.retouch_received_by
          } else {
            icon = 'fa-clock'
            status = 'Pending QC'
            status_by = 'All Images received'
          }
        }
      } else {
        icon = 'fa-clock'
        status = 'Pending Dispatch'
      }

      if (row.retouch_rejected_by) {
        icon = 'No'
        status = 'Rejected'
        status_by = row.retouch_rejected_by
      }

      if (this.checkForceComplete(row) == true) {
        status = 'Force Completed'
        icon = 'Yes'
      }

      return { 'status': status, 'status_by': status_by, 'status_at': status_at, 'icon': icon }
    },
    formatFinalImages (row) {
      if (this.checkForceComplete(row) == true) {
        return 'Yes'
      }
      if (row.final_sent_count == 0 || row.final_sent_count == null) {
        return 'No'
      } else if (row.retouch_received_count > row.final_sent_count) {
        return 'Pending'
      } else if (row.retouch_received_count == row.final_sent_count) {
        return 'Yes'
      } else {
        return 'No'
      }
    },

    updateColumns () {
      let columns = this.table_columns.group_1
      var hidden_columns = this.columns
      columns.forEach(function (o) {
        o.visible = true
      })
      if (!this.isEmpty(hidden_columns)) {
        hidden_columns.forEach(function (column) {
          columns.find((o, i) => {
            if (String(o.name) == String(column)) {
              o.visible = false
              return true
            }
          })
        })
      }
    },
    handleFlagClick: function (flag, row) {
      if (flag == 'Styling') {
        this.getProductHistory(row.ounass_id, 'Styling')
      }
      if (flag == 'Comment') {
        this.getProductHistory(row.ounass_id, 'Comment')
      }
    },
    getProductHistory: function (ounass_id, modal) {
      if (modal == 'Styling') this.togglePMModal()
      if (modal == 'Comment') this.togglePCModal()

      this.PMState = 'loading'
      this.PCState = 'loading'
      var self = this
      const url = '/photodesk/product/history/' + ounass_id
      this.$http.get(url, {
        dataType: 'json',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
        // mode: 'no-cors',
      })
        .then(function (response) {
          self.productHistory = response.data
          self.PMState = 'ready'
          self.PCState = 'ready'
        })
        .catch(function (error) {
          self.PMState = 'error'
          self.PCState = 'error'
        })
    },
    togglePMModal () {
      this.showPMModal = !this.showPMModal
    },
    togglePCModal () {
      this.showPCModal = !this.showPCModal
    },
    toggleAPCModal (row) {
      this.selectedProduct = row
      this.showAPCModal = !this.showAPCModal
    },
    toggleAPCModal (row) {
      this.selectedProduct = row
      this.showAPCModal = !this.showAPCModal
    },
    relocateProduct: function (row, location) {
      var self = this
      const url = '/reportdesk/product/relocate'
      let data = {
        'item': row.identifier,
        'channel': row.channel,
        'location': location
      }
      this.$http.post(url, data, {
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          console.log(response)
          self.$store.dispatch('updateToast', {
            text: response.data.status,
            show: true
          })
          row.location = response.data.location.location
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateToast', {
            text: error.message || error.data.message,
            show: true
          })
        })
    },
    formatRMSColumns (product) {
      var self = this
      let keys = []
      Object.keys(product).forEach(function (item) {
        if (item.startsWith('id_')) {
          return
        }
        keys.push({
          name: item,
          rowspan: 2,
          class: '',
          visible: true
        })
        self.product_columns.push(item)
      })
      this.table_columns_rms = {
        'group_1': keys
      }
      console.log(this.table_columns_rms)
    },
    useProductHeader (header) {
      var self = this
      const index = self.product_columns.indexOf(header)
      if (index > -1) {
        self.product_columns.splice(index, 1)
        return header
      } else {
        return false
      }
    }
  }

}
